import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    buttonContainer: {
        width: "100%"
    },
    container: {
        alignItems: "center",
        flex: 1
    },
    contentContainer: {
        alignItems: "center",
        width: "100%"
    },
    description: {
        textAlign: "center"
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    logo: {
        height: 150,
        width: 200
    },
    title: {
        textAlign: "center"
    }
});

export default stylesheet;
